var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { FormLinkComponent } from '../../../../../items/columns/link/link.component';
import { ColumnService } from '../../../../../items/columns/column/column.service';
import { ColumnBaseService } from '../../../../../items/columns/base/columnbase.service';
import { ConfigService } from '../../../../../service/config.service';
/*
    ファイルアップロードを行うコンポーネントで使用されるコンポーネント
    ダウンロードボタンクリックでファイルをダウンロードする
 */
var KtsFileDownloadComponent = /** @class */ (function (_super) {
    __extends(KtsFileDownloadComponent, _super);
    function KtsFileDownloadComponent(service, baseService, config) {
        var _this = _super.call(this, service, baseService, config) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.config = config;
        _this.fileName = '';
        _this.uuidFilePath = '';
        _this.host = _this.config.config['api_base'] || '';
        return _this;
    }
    KtsFileDownloadComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    KtsFileDownloadComponent.prototype.setValue = function () {
        _super.prototype.setValue.call(this);
        this.fileName = jsonpath.value(this.col, '$.params.fileName') || '';
        this.uuidFilePath = jsonpath.value(this.col, '$.params.uuidFilePath') || '';
        var query = JSON.stringify({ file: this.uuidFilePath, name: this.fileName });
        this.url = this.host + '/v1/file-download?query=' + encodeURIComponent(query);
    };
    KtsFileDownloadComponent.prototype.onClickButton = function (e) {
        this.linkElement.nativeElement.click();
    };
    KtsFileDownloadComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-column-file-download',
                    template: "\n        <a href=\"{{ url }}\" download=\"{{ fileName }}\" target=\"_blank\" [hidden]=\"true\" #link></a>\n        <column-button [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"{\n            controlType: 'button',\n            params: {\n                button: {\n                    type: 'button',\n                    event: '$fileDownload',\n                    caption: msg['au.COMPONENT.KtsFileDownloadComponent.button.download'],\n                    params: col?.params?.button?.params\n                }\n            }\n        }\" [msg]=\"msg\" (clickCol)=\"onClickButton($event)\"></column-button>\n    "
                }] }
    ];
    /** @nocollapse */
    KtsFileDownloadComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: ConfigService }
    ]; };
    KtsFileDownloadComponent.propDecorators = {
        linkElement: [{ type: ViewChild, args: ['link',] }]
    };
    return KtsFileDownloadComponent;
}(FormLinkComponent));
export { KtsFileDownloadComponent };
//# sourceMappingURL=file-download.component.js.map